__turbopack_context__.v({
  "className": "geist_ef09c865-module__Gk2seG__className",
  "variable": "geist_ef09c865-module__Gk2seG__variable",
});
